import { Resource as t, API as i } from "@coveo/platform-client";
const e = class e extends t {
  /**
   * Returns products linked to a user query on the defined catalog.
   */
  query(s) {
    return this.api.post(this.buildPath(e.baseUrl), s);
  }
};
e.baseUrl = `/rest/organizations/${i.orgPlaceholder}/commerce/v2/catalogSearch`;
let r = e;
export {
  r as CatalogSearch
};
//# sourceMappingURL=CatalogSearch.js.map
